
import { WorldCountry } from '../../types';
import { GLOBAL_EXPANSION_CONFIG } from './expansionConfig';

/**
 * Valida la cobertura global ultra después de la mega expansión
 */
export const validateGlobalCoverage = (countries: WorldCountry[]): void => {
  console.log('🔍 VALIDANDO COBERTURA GLOBAL ULTRA...');
  
  const issues: string[] = [];
  const warnings: string[] = [];
  const success: string[] = [];
  
  countries.forEach(country => {
    const expectedCities = GLOBAL_EXPANSION_CONFIG.targetCitiesPerCountry[country.slug] || 30;
    const actualCities = country.topCities.length;
    
    if (actualCities < expectedCities * 0.7) {
      issues.push(`❌ ${country.name}: ${actualCities}/${expectedCities} ciudades (déficit crítico)`);
    } else if (actualCities < expectedCities * 0.9) {
      warnings.push(`⚠️ ${country.name}: ${actualCities}/${expectedCities} ciudades (déficit menor)`);
    } else {
      success.push(`✅ ${country.name}: ${actualCities}/${expectedCities} ciudades (objetivo cumplido)`);
    }
    
    // Validar que todas las ciudades tengan más de 50,000 habitantes
    const smallCities = country.topCities.filter(city => city.population < 50000);
    if (smallCities.length > 0) {
      warnings.push(`⚠️ ${country.name}: ${smallCities.length} ciudades con menos de 50,000 habitantes`);
    }
  });
  
  if (issues.length === 0 && warnings.length === 0) {
    console.log('✅ 🌟 COBERTURA GLOBAL ULTRA PERFECTA - Sin problemas detectados 🌟 ✅');
    console.log(`🎯 ${success.length} países con cobertura completa`);
  } else {
    if (issues.length > 0) {
      console.error('❌ PROBLEMAS CRÍTICOS DETECTADOS:');
      issues.slice(0, 5).forEach(issue => console.error(`   ${issue}`));
      if (issues.length > 5) console.error(`   ... y ${issues.length - 5} problemas críticos más`);
    }
    
    if (warnings.length > 0) {
      console.warn('⚠️ ADVERTENCIAS:');
      warnings.slice(0, 5).forEach(warning => console.warn(`   ${warning}`));
      if (warnings.length > 5) console.warn(`   ... y ${warnings.length - 5} advertencias más`);
    }
    
    console.log(`✅ ÉXITOS: ${success.length} países con cobertura completa`);
  }
};
